export default "__VITE_ASSET__Bkx2naSa__"